import styled from 'styled-components'

import { color, spacing, typography } from '../../themes'
import { Grid } from '../Grid'

export const Container = styled.div``

export const HeaderRow = styled(Grid)`
  background: ${color('gray.05')};
`

export const HeaderItem = styled.div`
  ${typography('caption1')};
  padding: ${spacing(2, 2.5)};
`

export const TimetableRow = styled(Grid)`
  border-bottom: 1px solid ${color('gray.04')};
  padding: ${spacing(3, 0)};
  /* min-height: 138px; */

  & > *:first-of-type {
    border-right: 1px solid ${color('gray.04')};
  }
`
